import { type StateType } from '../../../states';
import { type EntitiesTournaments } from '../../../states/entities/tournaments';
import { type TournamentState } from '../../../states/entities/tournaments';
import { type Selector } from '../../../types/selectors';
import { type TopCompetitionLevel } from '../../../types/tournaments';
import { type TournamentId } from '../../../types/tournaments';
import { getTournamentIdFromProps } from '../../_propsGetters_';
import { selectEntitiesState } from '../entitiesPrimary.selector';

const emptyObject = {};

export const selectEntitiesTournaments: Selector<EntitiesTournaments> = (state: StateType) =>
  selectEntitiesState(state).tournaments ?? emptyObject;

//#region state.entities.tournaments
export type EntitiesTournamentsSelectorProps = {
  tournamentId?: TournamentId;
};

export const selectEntitiesTournamentsEntity: Selector<TournamentState | undefined> = (
  state: StateType,
  props: EntitiesTournamentsSelectorProps = {},
) => {
  const tournamentId = getTournamentIdFromProps(state, props);

  if (tournamentId) {
    return selectEntitiesTournaments(state)[tournamentId];
  }
};
//#endregion

//#region state.entities.tournaments
export const selectEntitiesTournamentsEntityTournamentId: Selector<number | undefined> = (
  state: StateType,
  props: EntitiesTournamentsSelectorProps = {},
) => selectEntitiesTournamentsEntity(state, props)?.tournamentId;

export const selectEntitiesTournamentsEntitySrTournamentId: Selector<string | undefined> = (
  state: StateType,
  props: EntitiesTournamentsSelectorProps = {},
) => selectEntitiesTournamentsEntity(state, props)?.srTournamentId;

export const selectEntitiesTournamentsEntitySrSeasonId: Selector<string | undefined> = (
  state: StateType,
  props: EntitiesTournamentsSelectorProps = {},
) => selectEntitiesTournamentsEntity(state, props)?.srSeasonId;

export const selectEntitiesTournamentsEntityTournamentName: Selector<string | undefined> = (
  state: StateType,
  props: EntitiesTournamentsSelectorProps = {},
) => selectEntitiesTournamentsEntity(state, props)?.tournamentName;

export const selectEntitiesTournamentsEntityMainMatchCount: Selector<number | undefined> = (
  state: StateType,
  props: EntitiesTournamentsSelectorProps = {},
) => selectEntitiesTournamentsEntity(state, props)?.mainMatchCount;

export const selectEntitiesTournamentsEntityLiveMatchCount: Selector<number | undefined> = (
  state: StateType,
  props: EntitiesTournamentsSelectorProps = {},
) => selectEntitiesTournamentsEntity(state, props)?.liveMatchCount;

export const selectEntitiesTournamentsEntityTvMatchCount: Selector<number | undefined> = (
  state: StateType,
  props: EntitiesTournamentsSelectorProps = {},
) => selectEntitiesTournamentsEntity(state, props)?.tvMatchCount;

export const selectEntitiesTournamentsEntityDisableTracker: Selector<boolean> = (
  state: StateType,
  props: EntitiesTournamentsSelectorProps = {},
) => selectEntitiesTournamentsEntity(state, props)?.disableTracker ?? false;

export const selectEntitiesTournamentsEntityDisablePlayerStats: Selector<boolean> = (
  state: StateType,
  props: EntitiesTournamentsSelectorProps = {},
) => selectEntitiesTournamentsEntity(state, props)?.disablePlayerStats ?? false;

export const selectEntitiesTournamentsEntityDisplayCupRoster: Selector<boolean> = (
  state: StateType,
  props: EntitiesTournamentsSelectorProps = {},
) => selectEntitiesTournamentsEntity(state, props)?.displayCupRoster ?? false;

export const selectEntitiesTournamentsEntityDisplayLiveTable: Selector<boolean> = (
  state: StateType,
  props: EntitiesTournamentsSelectorProps = {},
) => selectEntitiesTournamentsEntity(state, props)?.displayLiveTable ?? false;

export const selectEntitiesTournamentsEntityFilters: Selector<Array<number> | undefined> = (
  state: StateType,
  props: EntitiesTournamentsSelectorProps = {},
) => selectEntitiesTournamentsEntity(state, props)?.filters;

export const selectEntitiesTournamentsEntityFlag: Selector<string | undefined> = (
  state: StateType,
  props: EntitiesTournamentsSelectorProps = {},
) => selectEntitiesTournamentsEntity(state, props)?.flag;

export const selectEntitiesTournamentsEntityTopLevel: Selector<TopCompetitionLevel | undefined> = (
  state: StateType,
  props: EntitiesTournamentsSelectorProps = {},
) => selectEntitiesTournamentsEntity(state, props)?.topLevel;

export const selectEntitiesTournamentsEntityTopName: Selector<string | undefined> = (
  state: StateType,
  props: EntitiesTournamentsSelectorProps = {},
) => selectEntitiesTournamentsEntity(state, props)?.topName;

export const selectEntitiesTournamentsEntityPrematchPromo: Selector<string | undefined> = (
  state: StateType,
  props: EntitiesTournamentsSelectorProps = {},
) => selectEntitiesTournamentsEntity(state, props)?.prematchPromo;

export const selectEntitiesTournamentsEntityLivePromo: Selector<string | undefined> = (
  state: StateType,
  props: EntitiesTournamentsSelectorProps = {},
) => selectEntitiesTournamentsEntity(state, props)?.livePromo;
//#endregion
